module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-9.c158bded.mp3";